export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
    showFieldNotSelected: true,
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "count",
    activeCode: "",
    showFieldNotSelected: true,
  },
  {
    url: "/",
    name: "시스템 계약 현황",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/335",
        name: "하도급업체 등록",
        icon: "count",
        activeCode: "",
        groupName: ["335"],
      },
    ],
  },
  {
    url: "/",
    name: "현장현황",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace-ordering",
        name: "현장 현황",
        icon: "count",
        activeCode: "field-workplace-ordering",
        groupName: ["99"],
        showFieldNotSelected: true, // 사업장이 선택되지 않았을 때 표시되는 메뉴
      },
      {
        url: "/tab/688",
        name: "수급인 정보",
        icon: "count",
        activeCode: "",
        groupName: ["688"],
      },
    ],
  },
  {
    url: "/",
    name: "안전보건조직체계",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/527",
        name: "안전보건 조직 체계도",
        icon: "count",
        activeCode: "",
        groupName: ["527"],
      },
      {
        url: "/tab/139",
        name: "유관기관 비상연락망",
        icon: "count",
        activeCode: "",
        groupName: ["139"],
      },
      {
        url: "/tab/285",
        name: "안전보건관리 책임자 지정 외",
        icon: "count",
        activeCode: "",
        groupName: ["285", "282", "491"],
      },
    ],
  },
  {
    url: "/",
    name: "안전보건관리체계",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/259",
        name: "안전 및 보건에 관한 협의체",
        icon: "count",
        activeCode: "",
        groupName: ["259", "330"],
      },
    ],
  },
  {
    url: "/",
    name: "현장 안전·보건점검",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/100",
        name: "합동 안전점검",
        icon: "count",
        activeCode: "",
        groupName: ["100"],
      },
      {
        url: "/tab/163",
        name: "작업장 순회점검일지",
        icon: "count",
        activeCode: "",
        groupName: ["163"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/522",
        name: "최초 위험성평가",
        icon: "count",
        activeCode: "",
        groupName: ["522", "332", "509"],
      },
      {
        url: "/tab/523",
        name: "수시 위험성평가",
        icon: "count",
        activeCode: "",
        groupName: ["523", "334", "510"],
      },
      {
        url: "/tab/528",
        name: "TBM 회의록",
        icon: "count",
        activeCode: "",
        groupName: ["528"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 교육",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/107",
        name: "안전·보건 교육",
        icon: "count",
        activeCode: "",
        groupName: ["107"],
      },
    ],
  },
  {
    url: "/",
    name: "안전작업계획",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/529",
        name: "안전작업계획서",
        icon: "count",
        activeCode: "",
        groupName: ["529", "524", "525"],
      },
      {
        url: "/tab/257",
        name: "작업허가서",
        icon: "count",
        activeCode: "",
        groupName: ["257", "530", "526"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 예산",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/250",
        name: "산업안전보건관리비",
        icon: "count",
        activeCode: "",
        groupName: ["250"],
      },
    ],
  },
  // {
  //   url: "/",
  //   name: "재해발생 시 조치",
  //   icon: "count",
  //   activeCode: "",
  // },
  {
    url: "/",
    name: "재해발생 보고",
    icon: "count",
    activeCode: "",
    submenu: [
      {
        url: "/tab/117",
        name: "산업재해조사표",
        icon: "count",
        activeCode: "",
        groupName: ["117"],
      },
      {
        url: "/tab/244",
        name: "중대재해 발생 보고",
        icon: "count",
        activeCode: "",
        groupName: ["244"],
      },
      {
        url: "/tab/307",
        name: "안전사고 발생 보고서",
        icon: "count",
        activeCode: "",
        groupName: ["307"],
      },
      {
        url: "/tab/308",
        name: "재발방지 조치 보고서",
        icon: "count",
        activeCode: "",
        groupName: ["308"],
      },
    ],
  },

  //////////////////////////////////////////////////

  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "공지사항",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ["16"],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ["17"],
      },
      {
        url: "/community/healthinfo",
        name: "안전보건 주요일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ["18"],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ["19"],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    showFieldNotSelected: true, // 사업장이 선택되지 않았을 때 표시되는 메뉴
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ["90"],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ["91"],
      },
      {
        url: "/mypage/info-update",
        name: "개인정보변경",
        slug: "",
        icon: "w-line",
        groupName: ["92"],
      },
      {
        url: "/",
        name: "결재관리",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/approval-request",
            name: "결재요청함",
            slug: "",
            icon: "w-line",
            groupName: ["93"],
          },
          {
            url: "/approval-await",
            name: "결재대기함",
            slug: "",
            icon: "w-line",
            groupName: ["94"],
          },
          {
            url: "/approval-process",
            name: "결재진행함",
            slug: "",
            icon: "w-line",
            groupName: ["95"],
          },
          {
            url: "/approval-complete",
            name: "완료문서함",
            slug: "",
            icon: "w-line",
            groupName: ["96"],
          },
          {
            url: "/approval-reject",
            name: "반려문서함",
            slug: "",
            icon: "w-line",
            groupName: ["97"],
          },
          {
            url: "/approval-reference",
            name: "참조/회람문서함",
            slug: "",
            icon: "w-line",
            groupName: ["98"],
          },
        ],
      },
    ],
  },
];
